import { render, staticRenderFns } from "./JournalReport.vue?vue&type=template&id=e1968772"
import script from "./JournalReport.vue?vue&type=script&lang=js"
export * from "./JournalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports